export function findImprovements(oldTimes, newTimes) {
    const toSecs = (t) => {
        const parts = t.split(':');
        return parts.length === 2 ? parseInt(parts[0]) * 60 + parseFloat(parts[1]) : parseFloat(parts[0]);
    };
    const toTimeStr = (s) => {
        const mins = Math.floor(s / 60);
        const secs = (s % 60).toFixed(2);
        return mins > 0 ? `${mins}:${secs.padStart(5, '0')}` : secs;
    };
    const oldBest = new Map();
    for (const t of oldTimes) {
        const key = `${t.event}:::${t.course}`;
        const existing = oldBest.get(key);
        if (!existing || toSecs(t.time) < toSecs(existing))
            oldBest.set(key, t.time);
    }
    const newBest = new Map();
    for (const t of newTimes) {
        const key = `${t.event}:::${t.course}`;
        const existing = newBest.get(key);
        if (!existing || toSecs(t.time) < toSecs(existing.time)) {
            newBest.set(key, { event: t.event, course: t.course, time: t.time });
        }
    }
    const results = [];
    for (const [key, { event, course, time: newTime }] of newBest) {
        const previousBest = oldBest.get(key);
        if (!previousBest || toSecs(newTime) >= toSecs(previousBest))
            continue;
        const delta = toSecs(previousBest) - toSecs(newTime);
        results.push({ event, course, newTime, previousBest, improvement: toTimeStr(delta) });
    }
    return results.sort((a, b) => toSecs(b.improvement ?? '0') - toSecs(a.improvement ?? '0'));
}
